
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="py-8 bg-gray-50 border-t border-gray-200">
      <div className="container mx-auto px-4">
        <div className="flex justify-center items-center">
          <nav className="flex justify-center gap-8">
            <a href="https://system1.com/terms/privacy-policy" target="_blank" className="text-sm text-gray-500 hover:text-gray-700">Privacy Policy</a>
            <Link to="/uninstall" className="text-sm text-gray-500 hover:text-gray-700">Uninstall</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
